import { RequestQuoteSubmittedEvent } from '../../../requestQuote/RequestQuotePageEvents';
import type { StoreState } from '../../../StoreState';
import { IEventAggregator } from '../../EventAggregator';
import { Analytics } from '../Analytics';
import { ProductDataConverter } from '../converters/ProductDataConverter';

export class RequestQuoteAnalyticsListener {
  constructor(
    eventAggregator: IEventAggregator,
    private readonly getStore: () => StoreState,
  ) {
    eventAggregator.subscribe(RequestQuoteSubmittedEvent, (e) => this.onRequestQuoteSubmitted(e));
  }

  private onRequestQuoteSubmitted(e: RequestQuoteSubmittedEvent) {
    Analytics.trackGenerateLead({
      consentGranted: e.formData.consentGranted,
      countryName: e.formData.countryName,
      currency: e.currencyCode,
      customerType: e.formData.customerType,
      product: ProductDataConverter.fromBaseModelBasicData(
        e.product,
        this.getStore().canBePurchased(e.product),
        e.configurationCode,
        undefined,
        e.formData.quantity,
      ),
    });
  }
}
